// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopTokenizationControllerFinishAddCardTokenizationData } from './EshopTokenizationControllerFinishAddCardTokenizationData.gen';
import type { EshopTokenizationControllerFinishAddCardTokenizationErrors } from './EshopTokenizationControllerFinishAddCardTokenizationErrors.gen';
import type { EshopTokenizationControllerFinishAddCardTokenizationResponses } from './EshopTokenizationControllerFinishAddCardTokenizationResponses.gen';
import type { EshopTokenizationControllerFinishPortableCardTokenizationData } from './EshopTokenizationControllerFinishPortableCardTokenizationData.gen';
import type { EshopTokenizationControllerFinishPortableCardTokenizationErrors } from './EshopTokenizationControllerFinishPortableCardTokenizationErrors.gen';
import type { EshopTokenizationControllerFinishPortableCardTokenizationResponses } from './EshopTokenizationControllerFinishPortableCardTokenizationResponses.gen';
import type { EshopTokenizationControllerFinishTokenizationData } from './EshopTokenizationControllerFinishTokenizationData.gen';
import type { EshopTokenizationControllerFinishTokenizationErrors } from './EshopTokenizationControllerFinishTokenizationErrors.gen';
import type { EshopTokenizationControllerFinishTokenizationResponses } from './EshopTokenizationControllerFinishTokenizationResponses.gen';
import type { EshopTokenizationControllerInitAddBankCardTokenizationData } from './EshopTokenizationControllerInitAddBankCardTokenizationData.gen';
import type { EshopTokenizationControllerInitAddBankCardTokenizationErrors } from './EshopTokenizationControllerInitAddBankCardTokenizationErrors.gen';
import type { EshopTokenizationControllerInitAddBankCardTokenizationResponses } from './EshopTokenizationControllerInitAddBankCardTokenizationResponses.gen';
import type { EshopTokenizationControllerInitAddInCardTokenizationData } from './EshopTokenizationControllerInitAddInCardTokenizationData.gen';
import type { EshopTokenizationControllerInitAddInCardTokenizationErrors } from './EshopTokenizationControllerInitAddInCardTokenizationErrors.gen';
import type { EshopTokenizationControllerInitAddInCardTokenizationResponses } from './EshopTokenizationControllerInitAddInCardTokenizationResponses.gen';
import type { EshopTokenizationControllerInitCardApplicationTokenizationData } from './EshopTokenizationControllerInitCardApplicationTokenizationData.gen';
import type { EshopTokenizationControllerInitCardApplicationTokenizationErrors } from './EshopTokenizationControllerInitCardApplicationTokenizationErrors.gen';
import type { EshopTokenizationControllerInitCardApplicationTokenizationResponses } from './EshopTokenizationControllerInitCardApplicationTokenizationResponses.gen';
import type { EshopTokenizationControllerInitPortableCardTokenizationData } from './EshopTokenizationControllerInitPortableCardTokenizationData.gen';
import type { EshopTokenizationControllerInitPortableCardTokenizationErrors } from './EshopTokenizationControllerInitPortableCardTokenizationErrors.gen';
import type { EshopTokenizationControllerInitPortableCardTokenizationResponses } from './EshopTokenizationControllerInitPortableCardTokenizationResponses.gen';
import type { Options } from './Options.gen';

export class EshopTokenizationController {
    /**
     * Zahájení tokenizace bankovní nebo IN karty přes žádost o kartu.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CANNOT_INIT_TOKENIZATION** - Tokenization cannot be initialized.
     */
    public static initCardApplicationTokenization<ThrowOnError extends boolean = false>(options: Options<EshopTokenizationControllerInitCardApplicationTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopTokenizationControllerInitCardApplicationTokenizationResponses, EshopTokenizationControllerInitCardApplicationTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/tokenization/init/card-application/{cardApplicationId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Zahájení tokenizace bankovní karty pro přidání k zákazníkovi.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CANNOT_INIT_TOKENIZATION** - Tokenization cannot be initialized.
     */
    public static initAddBankCardTokenization<ThrowOnError extends boolean = false>(options: Options<EshopTokenizationControllerInitAddBankCardTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopTokenizationControllerInitAddBankCardTokenizationResponses, EshopTokenizationControllerInitAddBankCardTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/tokenization/init/add-bank-card',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Zahájení tokenizace In karty pro přidání k zákazníkovi.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CANNOT_INIT_TOKENIZATION** - Tokenization cannot be initialized.
     */
    public static initAddINCardTokenization<ThrowOnError extends boolean = false>(options: Options<EshopTokenizationControllerInitAddInCardTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopTokenizationControllerInitAddInCardTokenizationResponses, EshopTokenizationControllerInitAddInCardTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/tokenization/init/add-in-card',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Zahájení tokenizace portable bankovní karty.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CANNOT_INIT_TOKENIZATION** - Tokenization cannot be initialized.
     */
    public static initPortableCardTokenization<ThrowOnError extends boolean = false>(options: Options<EshopTokenizationControllerInitPortableCardTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopTokenizationControllerInitPortableCardTokenizationResponses, EshopTokenizationControllerInitPortableCardTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/tokenization/init/portable-card',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Dokončení tokenizace karty.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CARD_APPLICATION** - Card application is invalid or does not exist.<br>
     * + **CHIP_NUMBER_NOT_UNIQUE** - Chip number already exists.<br>
     * + **CANNOT_FINISH_TOKENIZATION** - Tokenization cannot be finished.
     */
    public static finishTokenization<ThrowOnError extends boolean = false>(options: Options<EshopTokenizationControllerFinishTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopTokenizationControllerFinishTokenizationResponses, EshopTokenizationControllerFinishTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/tokenization/finish',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Dokončení tokenizace přidání karty.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CARD_APPLICATION** - Card application is invalid or does not exist.<br>
     * + **CHIP_NUMBER_NOT_UNIQUE** - Chip number already exists.<br>
     * + **CANNOT_FINISH_TOKENIZATION** - Tokenization cannot be finished.
     */
    public static finishAddCardTokenization<ThrowOnError extends boolean = false>(options: Options<EshopTokenizationControllerFinishAddCardTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopTokenizationControllerFinishAddCardTokenizationResponses, EshopTokenizationControllerFinishAddCardTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/tokenization/finish/add-card',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Dokončení tokenizace portable bankovní karty.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CARD_APPLICATION** - Card application is invalid or does not exist.<br>
     * + **CHIP_NUMBER_NOT_UNIQUE** - Chip number already exists.<br>
     * + **CANNOT_FINISH_TOKENIZATION** - Tokenization cannot be finished.
     */
    public static finishPortableCardTokenization<ThrowOnError extends boolean = false>(options: Options<EshopTokenizationControllerFinishPortableCardTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopTokenizationControllerFinishPortableCardTokenizationResponses, EshopTokenizationControllerFinishPortableCardTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/tokenization/finish/portable-card',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
